import './banner.css';
import { NavLink } from 'react-router';
import { useAzureAuth } from '../../../hooks/use_azure_auth.ts';

function Banner() {
    const user = useAzureAuth();

    function handleUserCornerClick() {
        if (user.userProps.token) {
            user.logout();
        } else {
            user.login().catch();
        }
    }

    return (
        <div className="main_banner">
            <NavLink to={`/`} className="main_banner__branding">
                <img
                    src="https://stazweuathenastorage.blob.core.windows.net/static/images/sensirion_logo_h75.png"
                    alt="Branding"
                />
                <div className="main_banner__text">Driver Index</div>
            </NavLink>
            <div
                className="main_banner__username"
                onClick={handleUserCornerClick}
                title={
                    user.userProps.token
                        ? 'click to logout'
                        : 'Sensirion employee login'
                }
            >
                {user.userProps.token
                    ? user.userProps.username
                    : 'employee login'}
            </div>
        </div>
    );
}

export default Banner;
